import { Option } from "@jutro/types";

export const supportedLanguagesOptions: Option<string>[] = [
  { value: "pl", label: "Polski" },
  { value: "en", label: "Angielski" },
  { value: "uk", label: "Ukraiński" },
];
